import {useCallback, useMemo} from "react";
import {OrganShareFilterWordType} from "../../../../types/organShare";

export function useOrganShareConverter() {
    const searchWordConverter = useMemo(
        () => ({
            [OrganShareFilterWordType.ID.toString()]: "관리자 아이디",
            [OrganShareFilterWordType.MANAGER_NAME.toString()]: "관리자 이름",
            [OrganShareFilterWordType.CELL_PHONE.toString()]: "관리자 전화번호",
            [OrganShareFilterWordType.ORGAN_NAME.toString()]: "소속명",
        }), []
    );

    const getSearchWordConverter = useCallback(
        (status: OrganShareFilterWordType) => searchWordConverter[status.toString()],
        [searchWordConverter]
    );

    return {
        getSearchWordConverter
    }
}